/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  SequencesAlignRequest,
  SequencesAlignResponse,
  SimilarityTreeRequest,
  SimilarityTreeResponse,
} from "../models/index";
import {
  SequencesAlignRequestToJSON,
  SequencesAlignResponseFromJSON,
  SimilarityTreeRequestToJSON,
  SimilarityTreeResponseFromJSON,
} from "../models/index";

export interface AlignRequest {
  sequencesAlignRequest?: SequencesAlignRequest;
}

export interface OrderRequest {
  sequencesAlignRequest?: SequencesAlignRequest;
}

export interface TreeRequest {
  similarityTreeRequest?: SimilarityTreeRequest;
}

/**
 *
 */
export class AlignApi extends runtime.BaseAPI {
  /**
   * Given a list of sequences, perform multiple alignment on them and return the aligned sequences
   * Align Sequences
   */
  async alignRaw(
    requestParameters: AlignRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SequencesAlignResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/sequences/align`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SequencesAlignRequestToJSON(requestParameters.sequencesAlignRequest),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => SequencesAlignResponseFromJSON(jsonValue));
  }

  /**
   * Given a list of sequences, perform multiple alignment on them and return the aligned sequences
   * Align Sequences
   */
  async align(
    requestParameters: AlignRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SequencesAlignResponse> {
    const response = await this.alignRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Given a list of aligned sequences order them according to their similarity
   * Order sequences by similarity
   */
  async orderRaw(
    requestParameters: OrderRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SequencesAlignResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/sequences/order`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SequencesAlignRequestToJSON(requestParameters.sequencesAlignRequest),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => SequencesAlignResponseFromJSON(jsonValue));
  }

  /**
   * Given a list of aligned sequences order them according to their similarity
   * Order sequences by similarity
   */
  async order(
    requestParameters: OrderRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SequencesAlignResponse> {
    const response = await this.orderRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Given a list of aligned sequences, provide an ordered tree based on their pairwise similarity
   * Provide similarity tree
   */
  async treeRaw(
    requestParameters: TreeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SimilarityTreeResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/sequences/tree`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SimilarityTreeRequestToJSON(requestParameters.similarityTreeRequest),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => SimilarityTreeResponseFromJSON(jsonValue));
  }

  /**
   * Given a list of aligned sequences, provide an ordered tree based on their pairwise similarity
   * Provide similarity tree
   */
  async tree(
    requestParameters: TreeRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SimilarityTreeResponse> {
    const response = await this.treeRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
